var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTimeGlass = function SvgTimeGlass(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF968F",
    d: "M24 46.588C36.475 46.588 46.59 36.475 46.59 24S36.475 1.412 24 1.412 1.412 11.525 1.412 24 11.525 46.588 24 46.588"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M30.425 34.836H17.719c.07-3.635 1.8-7.27 5.188-10.235.67-.6.67-1.624 0-2.224-3.388-3-5.118-6.635-5.188-10.27h12.706c-.106 3.635-1.836 7.27-5.189 10.27a1.48 1.48 0 0 0 0 2.224c3.353 2.965 5.118 6.6 5.189 10.235"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFC536",
    d: "M29.684 34.13H18.46c.035-.389.141-.742.247-1.13.635-1.8 2.223-3.494 4.659-4.976.353-.212.564-.459.67-.777.106.283.353.565.671.777.67.388 1.27.812 1.8 1.235 1.87 1.482 2.965 3.176 3.176 4.87M21.884 20.33c.459.53.953 1.024 1.517 1.518.353.318.565.706.671 1.13a2.3 2.3 0 0 1 .67-1.13 15.4 15.4 0 0 0 1.518-1.518z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFB612",
    d: "M29.684 34.13H18.46c.035-.388.141-.741.247-1.13 1.306-.035 2.612-.211 3.847-.635 1.624-.564 3.106-1.658 3.988-3.07 1.836 1.447 2.93 3.141 3.141 4.835"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#A8644C",
    d: "M31.977 36.178H16.024c0-.776.636-1.412 1.412-1.412h13.13c.776-.035 1.411.636 1.411 1.412"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#9B543E",
    d: "M16.095 35.719c-.035.14-.07.282-.07.458h15.988c0-.176-.036-.317-.07-.459z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#A8644C",
    d: "M32.4 37.767H15.6a.8.8 0 0 1-.81-.812c0-.459.352-.812.81-.812h16.765c.46 0 .812.353.812.812s-.353.812-.776.812M16.024 11.824h15.989c0 .777-.636 1.412-1.412 1.412H17.436c-.776.035-1.412-.635-1.412-1.412"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#9B543E",
    d: "M31.907 12.283c.035-.141.07-.282.07-.459H16.024c0 .177.036.318.071.459z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#A8644C",
    d: "M15.6 10.236h16.765c.46 0 .812.353.812.812a.8.8 0 0 1-.812.812H15.601a.8.8 0 0 1-.812-.812c.035-.459.388-.812.812-.812"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M18.46 10.906c-1.554.07-2.754 1.377-2.683 2.894-.035-.776-.388-1.447-.882-1.941a2.74 2.74 0 0 0-2.012-.741c1.553-.07 2.753-1.377 2.682-2.894.07 1.553 1.341 2.753 2.894 2.682"
  })));
};
export default SvgTimeGlass;